/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Manager_Permissions_UpdatedInputs */

const en_knp_manager_permissions_updated = /** @type {(inputs: Knp_Manager_Permissions_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guide permissions updated`)
};

const fr_knp_manager_permissions_updated = /** @type {(inputs: Knp_Manager_Permissions_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autorisations du guide mises à jour`)
};

const de_knp_manager_permissions_updated = /** @type {(inputs: Knp_Manager_Permissions_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechtigungen für den Leitfaden aktualisiert`)
};

const it_knp_manager_permissions_updated = /** @type {(inputs: Knp_Manager_Permissions_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autorizzazioni della guida aggiornate`)
};

const ru_knp_manager_permissions_updated = /** @type {(inputs: Knp_Manager_Permissions_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновлены разрешения для гида.`)
};

const es_knp_manager_permissions_updated = /** @type {(inputs: Knp_Manager_Permissions_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permisos de guía actualizados`)
};

const zh_cn2_knp_manager_permissions_updated = /** @type {(inputs: Knp_Manager_Permissions_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向导权限已更新`)
};

const ja_knp_manager_permissions_updated = /** @type {(inputs: Knp_Manager_Permissions_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ガイド権限が更新されました`)
};

const hi_knp_manager_permissions_updated = /** @type {(inputs: Knp_Manager_Permissions_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गाइड की अनुमतियाँ अपडेट कर दी गईं`)
};

const pt_pt2_knp_manager_permissions_updated = /** @type {(inputs: Knp_Manager_Permissions_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permissões do guia atualizadas`)
};

/**
* | output |
* | --- |
* | "Guide permissions updated" |
*
* @param {Knp_Manager_Permissions_UpdatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_permissions_updated = /** @type {((inputs?: Knp_Manager_Permissions_UpdatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_Permissions_UpdatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_manager_permissions_updated(inputs)
	if (locale === "de") return de_knp_manager_permissions_updated(inputs)
	if (locale === "it") return it_knp_manager_permissions_updated(inputs)
	if (locale === "ru") return ru_knp_manager_permissions_updated(inputs)
	if (locale === "es") return es_knp_manager_permissions_updated(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_manager_permissions_updated(inputs)
	if (locale === "ja") return ja_knp_manager_permissions_updated(inputs)
	if (locale === "hi") return hi_knp_manager_permissions_updated(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_manager_permissions_updated(inputs)
	return en_knp_manager_permissions_updated(inputs)
});